module.exports = __webpack_public_path__ + "img/dang5.e6374d13.png";